import React, { Component } from "react";
import { Nav, Navbar, Image } from "react-bootstrap";
import { store } from "react-notifications-component";

import ModalForgot from "../Forgot";
import ModalEcom from "./ecomModal";
import Translate from "../../translate";
import LogoImage from "../../Images/Logos/LogoBlanco.png";
// import LogoWirebit from '../../Images/Logos/LogoAzul.png'

import Connection from "../../Calls";
import Backend from "../../Backend";
import { ThemeConsumer } from "styled-components";

import LanguageSelector from "./LanguageSelector";

class NavbarExternIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModalLogin: false,
      showModalForgot: false,
      logged: false,
      selected: "wallets",
    };
    this.handleCloseLogin = this.handleCloseLogin.bind(this);
    this.handleCloseForgot = this.handleCloseForgot.bind(this);
    this.handleShowForgot = this.handleShowForgot.bind(this);
    this.handleForgotPassword = this.handleForgotPassword.bind(this);
    this.handleReturnLogin = this.handleReturnLogin.bind(this);
  }

  handleCloseLogin() {
    this.setState({ showModalLogin: false });
  }

  handleCloseForgot() {
    this.setState({ showModalForgot: false });
  }

  handleShowForgot() {
    this.setState({ showModalForgot: true });
  }

  handleForgotPassword() {
    const self = this;
    self.setState({ showModalLogin: false });
    setTimeout(function () {
      self.setState({ showModalForgot: true });
    }, 500);
  }

  handleReturnLogin() {
    const self = this;
    self.setState({ showModalForgot: false });
    setTimeout(function () {
      self.setState({ showModalLogin: true });
    }, 500);
  }

  redirectRegister() {
    this.props.data.data.history.push("/register");
  }

  redirectLanding() {
    this.props.data.data.history.push("/");
  }

  logout() {
    const self = this;
    let date = new Date(),
      confirmation = Connection.Uwx6GVhZ(),
      result = "",
      combination = Connection.RThzHrsb("XCHF101"),
      latitude = "0",
      longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude;
    });
    result = latitude + longitude;
    Connection.EZcga8qH(
      confirmation,
      date,
      result,
      "XL7FefG",
      combination,
      "XCHF101",
      (response) => {
        var payload = response.payload;
        Backend.LoginOut(
          localStorage.getItem("email"),
          localStorage.getItem("token"),
          payload.r01,
          (response) => {
            let lRemove = ["token", "email", "alias", "vexchange", "ecomm", "type", "user_name", "user_first_last_name", "user_second_last_name", "lan"]
            lRemove.forEach(function(key){
              localStorage.removeItem(key)
            })
           window.location.href = "https://home.wirebit.com"; 
            if (response.status.code === "0") {
              store.addNotification({
                title: "Success!",
                message: response.payload.message,
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                  duration: 1800,
                  onScreen: true,
                },
              });
            } else {
              store.addNotification({
                title: "Error!",
                message: response.status.description,
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                  duration: 1800,
                  onScreen: true,
                },
              });
            }
          }
        );
      }
    );
  }

  redirect(uri) {
    this.props.data.data.history.push(uri);
  }

  checkForCommerce() {
    if (localStorage.getItem("ecomm") == "true")
      return this.props.data.data.history.push("/ecommerce");
    this.setState({ showEcomModal: true });
  }

  name() {
    const firstLetter = localStorage.getItem("user_name")?.charAt(0)?.toUpperCase();
    const restWord = localStorage.getItem("user_name")?.slice(1)?.toLowerCase();
    const camelCase = firstLetter + restWord;
    return camelCase;
  }

  render() {
    return (
      <div className="container_resize">
        <Navbar className="navbar_container_extern" fixed="top" expand="lg">
          <Navbar.Brand
            onClick={() => {
              this.redirectLanding();
            }}
            style={{ cursor: "pointer", position: "relative" }}
          >
            <Image src={LogoImage} style={{ width: 100 }} />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            {this.props.logged !== true ? (
              <Nav className="navbar_container_calc mr-auto">
                <div className="navbar_container_center">
                  {/* <Nav.Link className="navbar_extern_link">Solutions</Nav.Link>
                    <Nav.Link className="navbar_extern_link">Services</Nav.Link>
                    <Nav.Link className="navbar_extern_link">Resources</Nav.Link>
                    <Nav.Link className="navbar_extern_link">Company</Nav.Link>
                    <Nav.Link className="navbar_extern_link">Clients</Nav.Link> */}
                </div>
              </Nav>
            ) : (
              <Nav className="mr-auto">
                <div className="navbar_container_center">
                  <Nav.Link
                    className={
                      this.props.selected === "wallets"
                        ? "text-links-navbar-selected"
                        : "text-links-navbar"
                    }
                    onClick={() => {
                      this.redirect("/wallets");
                    }}
                  >
                    {" "}
                    {this.props.data.traductions.navbar.Wallets}{" "}
                  </Nav.Link>
                  <Nav.Link
                    className={
                      this.props.selected === "transactions"
                        ? "text-links-navbar-selected"
                        : "text-links-navbar"
                    }
                    onClick={() => {
                      this.redirect("/transactions");
                    }}
                  >
                    {" "}
                    {this.props.data.traductions.navbar.Transactions}{" "}
                  </Nav.Link>
                  <Nav.Link
                    className={
                      this.props.selected === "whitelist"
                        ? "text-links-navbar-selected"
                        : "text-links-navbar"
                    }
                    onClick={() => {
                      this.redirect("/whitelist");
                    }}
                  >
                    {" "}
                    {this.props.data.traductions.navbar.WhiteList}{" "}
                  </Nav.Link>
                  {
                    <Nav.Link
                      className={
                        this.props.selected === "virtualexchange"
                          ? "text-links-navbar-selected"
                          : "text-links-navbar"
                      }
                      onClick={() => {
                        this.redirect("/virtualexchange");
                      }}
                    >
                      {" "}
                      {this.props.data.traductions.navbar.Vex}{" "}
                    </Nav.Link>
                  }
                  {/* <Nav.Link className={(this.props.selected === "invoices") ?          "text-links-navbar-selected" : "text-links-navbar"} onClick={() => { this.redirect('/invoices') }}>          {this.props.data.traductions.navbar.Invoices}         </Nav.Link> */}
                  <Nav.Link
                    className={
                      this.props.selected === "card"
                        ? "text-links-navbar-selected"
                        : "text-links-navbar"
                    }
                    onClick={() => {
                      this.redirect("/card");
                    }}
                  >
                    {" "}
                    {this.props.data.traductions.navbar.Card}{" "}
                  </Nav.Link>
                  <Nav.Link
                    className={
                      this.props.selected === "withdrawal"
                        ? "text-links-navbar-selected"
                        : "text-links-navbar"
                    }
                    onClick={() => {
                      this.redirect("/withdrawal");
                    }}
                  >
                    {" "}
                    {this.props.data.traductions.navbar.Fiat_Withdrawal}{" "}
                  </Nav.Link>
                  <Nav.Link
                    className={
                      this.props.selected === "ecommerce"
                        ? "text-links-navbar-selected"
                        : "text-links-navbar"
                    }
                    onClick={() => {
                      this.checkForCommerce();
                    }}
                  >
                    {" "}
                    E-Commerce{" "}
                  </Nav.Link>
                </div>
              </Nav>
            )}
            {this.props.logged === true && (
              /*? (<div className="navbar_container_center" style={{ width: "auto" }}>
                  <Nav.Link className="navbar_extern_link_sign_up" onClick={() => { this.handleShowLogin() }}>{this.props.data.traductions.navbar.login}</Nav.Link>
                </div>)
                : */
              <div className="navbar_container_account">
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Image
                    src={require("../../Images/user_icon.svg")}
                    className="navbar_icon_user"
                    alt="user icon"
                    onClick={() => this.redirect("/settings")}
                  />
                  <p
                    className="navbar_greeting"
                    onClick={() => this.redirect("/settings")}
                  >
                    {this.props.data.traductions.navbar.greeting}{" "}
                    {this.name()}
                  </p>
                </div>
                <Image
                  src={require("../../Images/logout_icon.svg")}
                  className="navbar_icon_logout"
                  onClick={() => {
                    this.logout();
                  }}
                  alt={this.props.data.traductions.navbar.logout}
                />
                <LanguageSelector traductions={this.props.data.traductions} />
              </div>
            )}
          </Navbar.Collapse>
        </Navbar>
        <ModalForgot
          handleReturnLogin={this.handleReturnLogin}
          handleCloseForgot={this.handleCloseForgot}
          handleShowForgot={this.handleShowForgot}
          showModalForgot={this.state.showModalForgot}
          data={this.props}
        />
        <ModalEcom
          {...this.props.data.data}
          traductions={this.props.data.traductions}
          show={this.state.showEcomModal}
          onHide={() => this.setState({ showEcomModal: false })}
        />
      </div>
    );
  }
}
export default NavbarExternIndex;
